module.exports = __webpack_public_path__ + "assets/img/19.44c8ed31.png";